import * as apiGetCategoryTreeStartingWith from 'api/accessoryCategory/GetAccessoryCategoryTreeViewStartingWithV1';

export type Type = {
	children: Type[];
	id: string;
	name: string;
	parent: string;
};

export function create(): Type {
	return {
		children: [],
		id: '',
		name: '',
		parent: '',
	};
}

export async function getFromApi(searchTerm: string): Promise<Type[]> {
	const response = await apiGetCategoryTreeStartingWith.callApi(searchTerm, false);
	return response.getOrDefault([]);
}
